// extracted by mini-css-extract-plugin
export default {"marginRight":"f8w6za4voQm68p9GTaAr"};